export default {
  init() {
    $("#schoolselect").on("change", function() {
      window.location.href = '//' + window.location.hostname + '/' +$(this).val();
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js